export { default as LOCALES } from './locales';
export { default as REQUEST } from './request';
export { default as ROUTES } from './routes';
export { default as ERROR_MESSAGES } from './error-messages';

export const EVENTS_MINIMUM_CHARACTER = 3;
export const EVENTS_PER_PAGE = 3;

export const SHORT_NAME_MINIMUM_CHARACTER = 3;
export const SHORT_NAME_MAXIMUM_CHARACTER = 50;
export const TARGET_MIN = 1;
export const TARGET_MAX = 10000000;

export const AVATAR_TEMPLATE_SIZE = 'Size136x136Crop';

export const BLANK_RICHEDITOR_STATE = {
  document: {
    data: {},
    kind: 'document',
    nodes: [
      {
        data: {},
        kind: 'block',
        isVoid: false,
        type: 'paragraph',
        nodes: [
          {
            kind: 'text',
            ranges: [{ kind: 'range', text: '', marks: [] }],
          },
        ],
      },
    ],
  },
  kind: 'state',
};

export const DEFAULT_FRP_COVER_PHOTO = 'trainer-no-branding_web.jpg';
